





























































import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";
import { Action } from "vuex-class";
import { RestClient } from "@elite/restclient";
import { ILoginModel } from "../models";
import { GetUser, AppActionTypes, setAuthToken } from "../store";
import { HomeRoute } from "../router";
import IView from "./IView";

@Component
export default class Login extends Vue implements IView {
    @Inject()
    restClient!: RestClient;

    @Action(AppActionTypes.getUser)
    getUser!: GetUser;

    @Prop({ default: false })
    passwordReset!: boolean;
    @Prop({ required: true })
    title!: string;

    loading = false;
    loginError = false;

    model: ILoginModel = { emailAddress: "", password: "" };

    async login(e: BvModalEvent): Promise<void> {
        e.preventDefault();
        this.loading = true;

        const response = await this.restClient.postJson<string>(
            "/api/Authenticate",
            this.model
        );

        if (response.status !== 200 || !response.data) {
            this.loginError = true;
            this.loading = false;
            return;
        }

        setAuthToken(response.data);
        await this.getUser();

        // if we have a return url, redirect to it
        const returnUrl = this.$route.query.returnUrl;
        if (typeof returnUrl === "string") {
            await this.$router.push(returnUrl);
            return;
        }

        // go home if we're not already there
        if (this.$route.path !== HomeRoute.path) {
            await this.$router.push(HomeRoute.path);
        }
    }
}
